'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = require('store');

var _store2 = _interopRequireDefault(_store);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _fetch = require('./fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = {

  accountsFilter: '',

  getContext: function getContext() {
    return _store2.default.get(_constants.STORE_NAME);
  },
  setContext: function setContext(newContext) {
    /* Check if the new context has a all the required data in it. If it does not, but it does have a p-code, get the remaining data. If nothing, throw an error. i*/
    if (newContext.pCode && newContext.isMarketer !== undefined) {
      _store2.default.set(_constants.STORE_NAME, newContext);
      return _bluebird2.default.resolve(newContext);
    } else if (newContext.pCode) {
      return _fetch2.default.context(newContext.pCode).then(function (fullContext) {
        _store2.default.set(_constants.STORE_NAME, fullContext);
        return _bluebird2.default.resolve(fullContext);
      }).catch(function () {
        _store2.default.set(_constants.STORE_NAME, newContext);
        return _bluebird2.default.resolve(newContext);
      });
    }
    return _bluebird2.default.reject(new Error('You must provide at least the p-code to set the context for this app.'));
  },
  setContextParameter: function setContextParameter(key, value) {
    var currentContext = this.get();
    currentContext[key] = value;
    _store2.default.set(_constants.STORE_NAME, currentContext);
  },
  initContext: function initContext() {
    /* Use this method when no context is set and we'd like to init with one by launching the account selector and fetching the accounts.. */
  },
  getAccounts: function getAccounts() {
    if (this.accounts) {
      return _bluebird2.default.resolve(this.accounts);
    }
    return _fetch2.default.accounts();
  },
  setAccounts: function setAccounts(accounts) {
    this.accounts = accounts;
  }
};

exports.default = store;


//////////////////
// WEBPACK FOOTER
// ./node_modules/qc-global-navigation/src/store.js
// module id = 42
// module chunks = 0